import { Component, OnInit, OnDestroy } from "@angular/core";

import { MatDialog } from "@angular/material";
import { ProductLabelDialogComponent } from './product-label/product-label.component';
import { AddBatchDialogComponent } from '../add-batch/add-batch-dialog.component';
import { ParentChildLabelDialogComponent } from './parent-child-label/parent-child-label.component';
import { UniqueProductLabelDialogComponent } from './unique-product-label/unique-product-label.component';
import { ShowLabelComponent } from './show-label/show-label.component';
import { CreateExistingBatchLabelComponent } from './create-existing-batch-label/create-existing-batch-label.component';
import { BulkBatchLabelComponent } from "./bulk-batch-label/bulk-batch-label.component";

import { GlobalCfgService } from "src/services/globalcfg.service";

@Component({
  selector: "rm-manage-label",
  templateUrl: "./manage-label.component.html",
  styleUrls: ["./manage-label.component.css"]
})
export class ManageLabelComponent implements OnInit, OnDestroy {

  userSubscription: any;
  user: any;
  subscriptions: any = [];

  constructor(
    private dialog: MatDialog,
    private globalCfgService:GlobalCfgService,
  ) {}

  ngOnInit() {
    let u = this.globalCfgService.getFullUserObj();
    if (!u) {
      this.userSubscription = this.globalCfgService.userFetchedValue$.subscribe(user => {
        if (user) {
          this.user = user;
        }
      });
      this.subscriptions.push(this.userSubscription);
    } else {
      this.user = u;
    }
  }

  createProductLabel(type) {
    const dialogRef = this.dialog.open(ProductLabelDialogComponent, {
      disableClose: true,
      width: "450px",
      data: { title: 'Create ' + type + ' Label'}
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log("The dialog was closed", result);
    });
  }

  createLabel(type) {
    var data = {
      title: 'Create ' + type + ' Label'
    }
    if (type == 'Class') {
      data['type'] = 'cl'
    }

    const dialogRef = this.dialog.open(UniqueProductLabelDialogComponent, {
      disableClose: true,
      width: "450px",
      data: data
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log("The dialog was closed", result);
    });
  }

  addInstanceLevelLabel() {
    const dialogRef = this.dialog.open(AddBatchDialogComponent, {
      disableClose: true,
      width: "1024px",
      data: {
        title: 'Create Primary Label'
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log("The dialog was closed", result);
      // if (result.status) {
      // }
    });
  }

  addSecondaryLevelLabel() {
    const dialogRef = this.dialog.open(AddBatchDialogComponent, {
      disableClose: true,
      width: "1024px",
      data: {
        type: 'sl',
        title: 'Create Non-aggregated Secondary Label'
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log("The dialog was closed", result);
      // if (result.status) {
      // }
    });
  }

  addBatchLevelLabel() {
    const dialogRef = this.dialog.open(AddBatchDialogComponent, {
      disableClose: true,
      width: "1024px",
      data: {
        type: 'bl',
        title: 'Create Batch Level Label'
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log("The dialog was closed", result);
      if (result.status) {
        const dialogRef1 = this.dialog.open(ShowLabelComponent, {
          disableClose: true,
          width: "450px",
          data: {
            title: 'Batch Level Label',
            record: result
          }
        });

        dialogRef1.afterClosed().subscribe(result => {
          console.log("The dialog was closed", result);
        });
      }
    });
  }

  addParentChild(type, packageLevel, packageType) {
    const dialogRef = this.dialog.open(ParentChildLabelDialogComponent, {
      disableClose: true,
      width: "1024px",
      data: {
        title: 'Create ' + type + ' Label',
        packageLevel: packageLevel,
        packageType: packageType
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log("The dialog was closed", result);
      // if (result.status) {
      // }
    });
  }

  generateExistingBatchLabel() {
    const dialogRef = this.dialog.open(CreateExistingBatchLabelComponent, {
      disableClose: true,
      width: "450px",
      data: {
        // title: 'Create Existing Batch Label',
        title: 'Create Non-Aggregated Secondary Label'
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log("The dialog was closed", result);
      // if (result.status) {
      // }
    });
  }

  generateBluckBatchLabel() {
    const dialogRef = this.dialog.open(BulkBatchLabelComponent, {
      disableClose: true,
      width: "750px",
      data: {
        title: 'Create Bulk API Label'
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log("The dialog was closed", result);
    });
  }

  ngOnDestroy(){
  // prevent memory leak when component destroyed
  this.subscriptions.forEach(s => s.unsubscribe());
  }
}
